var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.65 5.904c0-1.123.12-1.726 1.92-1.726h2.403V0H9.126C4.508 0 2.88 2.091 2.88 5.607V8.32H0v4.18h2.88V25h5.763V12.5h3.845L13 8.322H8.641l.01-2.417z"}));
}

FacebookIcon.defaultProps = {"viewBox":"0 0 13 25"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
